import { useState } from 'react';
import { Tab, TabGroup } from '@sb1/ffe-tabs-react';
import { GiverdataTable } from './GiverdataTable';
import { GiverdataProjectList } from './giverdata-project-list/GiverdataProjectList';
import styles from './organization-giverdata.module.less';

const DETAILS = 'DETAILS';
const PROJECTS = 'PROJECTS';

const ShowGiverdata = ({ organizationId }) => {
    const [activeTab, setActiveTab] = useState(DETAILS);

    return (
        <>
            <TabGroup className={styles.tab}>
                <Tab selected={activeTab === DETAILS} onClick={() => setActiveTab(DETAILS)} aria-controls={DETAILS}>
                    Detaljer
                </Tab>

                <Tab selected={activeTab === PROJECTS} onClick={() => setActiveTab(PROJECTS)} aria-controls={PROJECTS}>
                    Pr. spleis
                </Tab>
            </TabGroup>
            {activeTab === DETAILS && <GiverdataTable organizationId={organizationId} />}
            {activeTab === PROJECTS && <GiverdataProjectList organizationId={organizationId} />}
        </>
    );
};

export default ShowGiverdata;
